import Recharts from './Recharts.jsx'

export default class RechartsLine extends Recharts {
  generateDecoration (state) {
    super.generateDecoration(state)
  }
}
